<template>
    <div class="f-action-group">
        <span v-if="label" class="f-action-group__label">{{ label }}</span>
        <div class="f-action-group__buttons">
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FActionGroup',
        props: {
            label: { type: String, default: undefined }
        }
    }
</script>

<style lang="stylus">
    .f-action-group
        display flex
        align-items center
        justify-content flex-end
        gap .6rem
        max-width 100%

    .f-action-group__label
        color #777
        flex 0 0 auto
        font-size .7rem
        font-weight 600
        letter-spacing .04em
        text-transform uppercase

    .f-action-group__buttons
        display flex
        flex-wrap wrap
        justify-content flex-end
        gap .3rem
        max-width 100%

    @media screen and (max-width: 768px)
        .f-action-group
            align-items stretch
            flex-direction column
            gap .25rem
            width 100%

        .f-action-group__buttons
            justify-content flex-start
            width 100%

            > .button
                flex 1 1 auto
</style>
